import React from 'react';
import {makeStyles, withStyles} from "@material-ui/core/styles/index";
import Typography from '@material-ui/core/Typography'
import Grid from "@material-ui/core/es/Grid/Grid";

const useStyles = makeStyles((theme) => {
    return {
        root: {
            marginTop: 50,
            ['@media (max-width:500px)']: {
                marginTop: 15,
                paddingBottom: 0,
                borderBottom: 'none',
            },
            paddingBottom: 40,
            borderBottom: '1px solid #eee',
        },
        h2: {
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 400,
            fontSize: '1.5rem',

            width: 447,
            marginLeft: 'auto',
            marginRight: 'auto',
            ['@media (max-width:500px)']: {
                marginLeft: 15,
                width: 'auto',
            }
        },
        grid: {
            maxWidth: 1000,
            ['@media (max-width:1000px)']: {
                maxWidth: '95%',
            },
            marginLeft: 'auto',
            marginRight: 'auto',
            marginTop: 20,
            '& a': {
                fontSize: '.9rem',
                textDecoration: 'none',
                color: '#000055',
                '&:hover': {
                    textDecoration: 'underline',
                }
            }
            },

    }}
);

export default function BrowseByMake(props) {
    const classes = useStyles();

    const cells = props.screenWidth <= 500 ? 3 : 6;

    const size = 12/cells;

    const makes = [
        'Acura',
        'Alfa Romeo',
        'Aston Martin',
        'Audi',
        'Bentley',
        'BMW',
        'Bugatti',
        'Buick',
        'Cadillac',
        'Can Am',
        'Chevrolet',
        'Chrysler',
        //'De Tomaso',
        'Dodge',
        'Ford',
        'GMC',
        'Honda',
        'HUMMER',
        'Hyundai',
        'Infiniti',
        'JEEP',
        'Kaiser',
        'Kia',
        'Lexus',
        'Lincoln',
        'Mazda',
        'Mercedes-Benz',
        'Mini',
        'Morgan',
        'NISSAN',
        'Oldsmobile',
        'Plymouth',
        'Pontiac',
        'Porsche',
        'Ram',
        'Rolls-royce',
        'Scion',
        'Shelby',
        'Spyker',
        'Subaru',
        'Sunbeam',
        'Toyota',
        'Volkswagen',
    ];

    return (
        <div className={classes.root}>
            <h2 className={classes.h2}>Browse by make</h2>
            <Grid container spacing={1} className={classes.grid}>
            {makes.map(make => {
                return <Grid item md={size} sm={size} xs={size}>
                    <Typography><a href={"/used-cars/"+make} title={make}>{make}</a></Typography>
                </Grid>
            })}
            </Grid>

        </div>
    );
}
